import InsertCommentIcon from "@mui/icons-material/InsertComment";
import WebStoriesIcon from "@mui/icons-material/WebStories";
import Backdrop from "@mui/material/Backdrop";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Slide from "@mui/material/Slide";
import Lottie from "lottie-react";
import { useEffect, useMemo, useRef, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import TinderCard from "react-tinder-card";
import shuffleArray from "shuffle-array";
import "swiper/css"; //basic
import "swiper/css/navigation";
import "swiper/css/pagination";
import CustomAnswerSheet from "../component/CustomAnswerSheet";
import "./PlayPage.css";

import HomeIcon from "@mui/icons-material/Home";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import UndoIcon from "@mui/icons-material/Undo";
import React from "react";
import { useDispatch } from "react-redux";
import animationData from "../assets/lottieData3.json";
import soundAnimation from "../assets/soundGIF.json";
import { setFalse, setTrue } from "../features/bgm/BgmSlice";
import "./Advanced.css";

const PlayPage = ({ customHudaList, play }) => {
    const dispatcher = useDispatch();
    const newHudaList = useRef(shuffleArray.pick(customHudaList, { picks: customHudaList.length }));
    const navigate = useNavigate();
    const [currentIndex, setCurrentIndex] = useState(newHudaList.current.length - 1);
    const currentIndexRef = useRef(currentIndex);
    const [controlledSwiper, setControlledSwiper] = useState(null);
    const soundRef = useRef();
    const swipeRef = useRef();
    const [lastDirection, setLastDirection] = useState();
    const [isPlaying, setIsPlaying] = useState(false);
    const [customImg, setCustomImg] = useState();
    const [isExplainBottomSheet, setExplainBottomSheet] = useState(false);
    const [isEhudaBottomSheet, setEhudaBottomSheet] = useState(false);
    const [hudaIndex, setHudaIndex] = useState(0);
    const [skeleton, setSkeleton] = useState(true);
    const [isAnimate, setIsAnimate] = useState(false);
    const [cardCount, setCardCount] = useState(5);
    const [isTimeout, setIsTimeout] = useState(false);
    const imgRef = useRef();
    const isWide = useMediaQuery({ query: "(min-width: 600px)" });
    const isLong = useMediaQuery({ query: "(min-height: 630px)" });
    const goBack = async () => {
        if (!canGoBack) return;
        const newIndex = currentIndex + 1;
        updateCurrentIndex(newIndex);
        await childRefs[newIndex].current.restoreCard();
    };
    function timeout(delay) {
        return new Promise((res) => setTimeout(res, delay));
    }
    const Transition = React.forwardRef(function Transition(props, ref) {
        return <Slide direction="up" ref={ref} {...props} />;
    });

    const [open, setOpen] = useState(false);
    const [loadList, setLoadList] = useState([]);
    const handleClose = () => {
        setOpen(false);
    };
    const handleOpen = () => {
        setOpen(true);
    };
    const [openModal, setOpenModal] = useState(false);
    const handleModalOpen = () => {
        setOpenModal(true);
    };
    const handleModalClose = () => {
        setOpenModal(false);
    };
    //renderingされても変数は残っている
    const count = useRef(0);
    useEffect(() => {

    }, []);
    useEffect(() => {
        setOpen(true);
        handleModalOpen();
        setCustomImg(newHudaList.current[0].yomiHuda);
    }, []);

    useEffect(() => {
        soundPause();
        setCustomImg(newHudaList.current[hudaIndex].yomiHuda);
    }, [hudaIndex]);

    function soundPlay() {
        setIsPlaying(true);
        dispatcher(setFalse());
        const playPromise = soundRef.current.play();
        if (playPromise !== undefined) {
            playPromise.then((_) => { }).catch((error) => { });
        }
    }
    const outOfFrame = (idx) => {

        // handle the case in which go back is pressed before card goes outOfFrame
        try {
            currentIndexRef.current >= idx && childRefs[idx].current.restoreCard();
        } catch (e) {
        
        }
        // TODO: when quickly swipe and restore multiple times the same card,
        // it happens multiple outOfFrame events are queued and the card disappear
        // during latest swipes. Only the last outOfFrame event should be considered valid
    };
    const childRefs = useMemo(
        () =>
            Array(newHudaList.current.length)
                .fill(0)
                .map((i) => React.createRef()),
        []
    );

    const updateCurrentIndex = (val) => {
        dispatcher(setTrue());
        setIsPlaying(false);
        setCurrentIndex(val);
        currentIndexRef.current = val;
    };

    const canGoBack = currentIndex < newHudaList.current.length - 1;

    const canSwipe = currentIndex >= 0;

    // set last direction and decrease current index
    const swiped = async (direction, index) => {
        if (index != 0) {
            setLastDirection(direction);
            updateCurrentIndex(index - 1);
        }
    };
    function soundPause() {
        setIsPlaying(false);
        if (soundRef.current.currentTime > 0 && soundRef !== null && soundRef !== undefined) {
            soundRef.current.pause();
        }
    }
    useEffect(() => {
        setOpen(true);
        let timer1 = setTimeout(() => setOpen(false), 3.9 * 1000);
        setIsTimeout(true);
        return () => {
            clearTimeout(timer1);
        };
    }, []);
    return (
        <div style={{ display: "flex", flexDirection: "column", overflow: "hidden" }}>
            <audio
                src={newHudaList.current[hudaIndex].sound}
                ref={soundRef}
                onEnded={() => {
                    setIsPlaying(false);
                }}
            ></audio>
            <div style={{ display: "flex", flexDirection: "column", overflow: "hidden" }}>
                <div className="play-page">
                    <link href="https://fonts.googleapis.com/css?family=Damion&display=swap" rel="stylesheet" />
                    <link href="https://fonts.googleapis.com/css?family=Alatsi&display=swap" rel="stylesheet" />
                    <audio
                        src={newHudaList.current[currentIndex].sound}
                        ref={soundRef}
                        onEnded={() => {
                            setIsPlaying(false);
                            dispatcher(setTrue());
                        }}
                    ></audio>
                    <div className={isWide ? "head-bar-wide" : "head-bar"}>
                        <IconButton
                            onClick={() => {
                                dispatcher(setTrue());
                                play();
                                navigate("/");
                            }}
                        >
                            <HomeIcon className={isWide ? "home-button-wide" : "home-button"} />
                        </IconButton>
                        <span
                            style={{
                                display: "flex",
                                alignItems: "center",
                                fontSize: isWide ? "3rem" : "2rem",
                                color: "rgb(228, 158, 74)",
                                position: "absolute",
                                left: "50%",
                                transform: "translate(-50%,0)",
                            }}
                        >
                            {newHudaList.current.length - currentIndex}/{newHudaList.current.length}
                        </span>
                        <IconButton
                            onClick={() => {
                                // dispatcher(buttonEffectSetTrue());
                                goBack();
                            }}
                        >
                            <UndoIcon className={isWide ? "home-button-wide" : "home-button"}></UndoIcon>
                        </IconButton>
                    </div>
                    <div className="play-image" style={{height:"45vh",userSelect:"none"}}  onClick={()=>{"Click"}}>
                        {newHudaList.current.map((element, index) => (
                            <div
                                style={{ display: "flex", justifyContent: "center" }}
                                key={index}
                          
                            >
                                <TinderCard
                                    ref={childRefs[index]}
                                    className="swipe"
                                    
                                    style={{ pointerEvents: "none", userSelect: "none" }}
                                    onSwipe={(dir) => swiped(dir, index)}
                                    onCardLeftScreen={() => outOfFrame(index)}
                                    flickOnSwipe={true}
                                    swipeThreshold={1}
                                    
                                    // preventSwipe={["left", "right", "up", "down"]}
                                    swipeRequirementType="position"
                                 
                                    
                                >
                                    <img
                                        src={element.yomiHuda}
                                        alt=""
                                        onLoad={(e) => {
                                            loadList.push(e);
                                       
                                        }}
                                        className={isLong ? "image-item image-untouchable" : "image-item-short image-untouchable"}
                                        loading={index >= newHudaList.current.length - 5 ? "eager" : "lazy"}
                                    />
                                </TinderCard>
                            </div>
                        ))}
                    </div>
                    
                    <div
                    style={{
                        display: "flex",
                        marginBottom:"0"
                    }}
                >
                    <div style={{ margin: "auto auto 0 auto", display: "flex", flexDirection: "column" }}>
                        <Button
                            style={{ width: "15rem" }}
                            className="answer-button"
                            component="label"
                            variant="contained"
                            tabIndex={-1}
                            onClick={() => {
                                play();
                             setExplainBottomSheet(true);
                            }}
                            startIcon={<WebStoriesIcon style={{ fontSize: "1.5rem" }} />}
                        >
                            <span style={{ fontSize: "1.5rem", fontWeight: "500" }}>解説をみる</span>
                        </Button>

                        <Button
                            style={{ marginTop: "1rem", width: "15rem" }}
                            className="answer-button"
                            component="label"
                            variant="contained"
                            tabIndex={-1}
                            onClick={() => {
                                play();
                                setEhudaBottomSheet(true);
                            }}
                            startIcon={<InsertCommentIcon style={{ fontSize: "1.5rem" }} />}
                        >
                            <span style={{ fontSize: "1.5rem", fontWeight: "500" }}>取り札をみる</span>
                        </Button>
                        <Button
                            style={{ marginTop: "1rem", width: "15rem" }}
                            className="answer-button"
                            component="label"
                            variant="contained"
                            tabIndex={-1}
                            onClick={() => {
                                play();
                                soundPlay();
                            }}
                            startIcon={<PlayCircleIcon style={{ fontSize: "1.5rem" }} />}
                        >
                            <span style={{ fontSize: "1.5rem", fontWeight: "500" }}>音声再生</span>
                        </Button>

                        {isPlaying && (
                            <div>
                                <Lottie
                                    style={{ width: "5rem", height: "5rem", margin: "auto" }}
                                    animationData={soundAnimation}
                                ></Lottie>
                            </div>
                        )}
                    </div>
                </div>
                </div>
            

                <div>
                    <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open} onClick={handleClose}>
                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", height: "100%" }}>
                            <div style={{ color: "white", fontSize: "3.5rem" }} className="kiwi-maru-medium">
                                スライドで
                                <br></br>
                                次の句へ
                            </div>
                            <Lottie style={{ width: "20rem", height: "20rem" }} animationData={animationData}></Lottie>
                        </div>
                    </Backdrop>
                </div>
                <CustomAnswerSheet
                    open={isExplainBottomSheet}
                    setOpenBottomSheet={setExplainBottomSheet}
                    yomiHuda={newHudaList.current[currentIndex].sdgsHuda}
                ></CustomAnswerSheet>
                  <CustomAnswerSheet
                    open={isEhudaBottomSheet}
                    setOpenBottomSheet={setEhudaBottomSheet}
                    yomiHuda={newHudaList.current[currentIndex].eHuda}
                ></CustomAnswerSheet>
            </div>
        </div>
    );
};
export default PlayPage;
